module.exports = __webpack_public_path__ + "img/구로디지털단지 삼겹살.750f52cc.png";